"use client";
import {
  Center,
  Separator,
  Span,
  Flex,
  Grid,
  GridItem,
  Stack,
  List,
} from "@chakra-ui/react";
import Image, { StaticImageData } from "next/image";
import DottedBgImage from "public/shared/dottedGradientBg.svg";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";

type Props = {
  title: string;
  image: StaticImageData;
  desc?: string[];
  points?: Array<{ label: string; text: string }>;
};

const WhyOneMindFrame = (props: Props) => {
  const HeadingVariants = useHeadingVariant();
  const TextVariant = useTextVariant();
  const { image, title, desc, points } = props;
  return (
    <Stack gap={8}>
      <Heading as="h2" variant={HeadingVariants} textAlign="center">
        {title}
      </Heading>
      <Grid
        gap={{ base: 0, md: 8 }}
        bgImage={`url(${DottedBgImage.src})`}
        backgroundPosition="center"
        bgSize="cover"
        templateColumns={{
          base: "repeat(1, 1fr)",
          md: "repeat(4, 1fr)",
        }}
        p={{ base: 6, md: 12 }}
        borderRadius="8px"
        mx="auto"
      >
        <GridItem colSpan={{ base: 1, md: 1 }}>
          <Center height="full">
            <Image
              src={image}
              alt="image"
              style={{
                maxHeight: "300px",
                objectFit: "contain",
                objectPosition: "center",
              }}
            />
          </Center>
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 3 }} pt={{ base: 4, md: 0 }}>
          <Flex
            direction={{ base: "column", md: "row" }}
            alignItems="center"
            height="100%"
          >
            <Separator
              orientation="vertical"
              color="white"
              height="100%"
              borderWidth="1px"
              display={{ base: "none", md: "block" }}
            />
            <List.Root variant="plain" ml={{ md: 12 }} gap={4} color="white">
              {desc &&
                desc.map((point, index) => (
                  <List.Item key={index}>
                    <List.Indicator>•</List.Indicator>
                    <Text variant={TextVariant}>{point}</Text>
                  </List.Item>
                ))}
            </List.Root>
            <List.Root variant="plain" ml={{ md: 12 }} gap={4}>
              {points &&
                points.map((point, index) => (
                  <List.Item key={index} color="white">
                    <List.Indicator>•</List.Indicator>
                    <Text variant={TextVariant} color="white">
                      <Span as="span" color="white" fontWeight="600">
                        {point.label} : {""}
                      </Span>
                      <Span as="span" color="white">
                        {point.text}
                      </Span>
                    </Text>
                  </List.Item>
                ))}
            </List.Root>
          </Flex>
        </GridItem>
      </Grid>
    </Stack>
  );
};

export default WhyOneMindFrame;
